import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Api } from "../utils/api";
import moment from "moment";

class VisitsListTable extends React.Component {
  constructor() {
    super();
    this.api = new Api();
    this.goTo = this.goTo.bind(this);
  }

  componentDidMount() {}

  goTo(location, params) {
    this.props.history.push(location, params);
  }

  render() {
    return (
      <div className="main-reqlist-container">
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left" width="250px">
                  Data de registo da visita
                </TableCell>
                <TableCell align="left" width="250px">
                  Data da visita
                </TableCell>
                <TableCell align="left" width="500px">
                  Equipamento
                </TableCell>
                <TableCell align="left" width="400px">
                  Cliente
                </TableCell>
                <TableCell align="left">Consultor(a) Familiar</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.visits &&
                this.props.visits.map((visit) => (
                  <TableRow
                    key={visit.pedido}
                    className="hand"
                    onClick={() => this.goTo(`/user_requests/${visit.pedido}`)}
                  >
                    <TableCell align="left">
                      {visit.visit_time_update
                        ? moment(visit.visit_time_update).format(
                            "YYYY-MM-DD HH:mm"
                          )
                        : "-"}
                    </TableCell>
                    <TableCell align="left">
                      {moment(visit.data_visita)
                        .subtract(1, "hour")
                        .format("YYYY-MM-DD HH:mm")}
                    </TableCell>
                    <TableCell align="left">{visit.equipamento}</TableCell>
                    <TableCell align="left">{visit.cliente}</TableCell>
                    <TableCell align="left">{visit.consultora}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
});

VisitsListTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(VisitsListTable));
